/**
 * Created by daniel on 23/04/17.
 */

export const getUiHoveredItem = (state) => state.editor.ui.hoveredItem;
export const getUiSelectedItem = (state) => state.editor.ui.selectedItem;
export const getUiItemCoords = (itemId, relativeTo) => {
  let item = document.getElementById(itemId);
  if (!item) return null;
  let thisRect = item.getBoundingClientRect();
  
  let relative = document.getElementById(relativeTo);
  if (!relative) return null;
  let relativeRect = relative.getBoundingClientRect();
  return {
    top: thisRect.top - relativeRect.top ,
    right: thisRect.right - relativeRect.left,
    bottom: thisRect.bottom - relativeRect.top,
    left: thisRect.left- relativeRect.left,
    width: thisRect.right - thisRect.left,
    height: thisRect.bottom - thisRect.top,
  }
};
/**
 *
 * @param state
 * @returns {ContentDefinition|null}
 */
export const getUiDraggedItem = (state) => state.editor.ui.draggedItem;
export const getUiDropzoneCoords = (state) => state.editor.ui.dropzoneCoords;
export const getUiToolboxVisibility = (state) => state.editor.ui.toolboxVisible;
export const getUiToolboxPinned = (state) => state.editor.ui.toolboxPinned;

export const getUiToolboxActiveTab = (state) => state.editor.ui.toolboxTab;


// WEBPACK FOOTER //
// ./src/App/Editor/state/ui/selectors.js